<template>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      absolute
      permanent
    >
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-menu</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Menu</v-list-item-title>

        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="viewPage(item)"
        >
          <v-tooltip :color="item.color" right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon class="mr-2">
                <v-icon :color="item.color">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content v-if="item.tooltip" v-bind="attrs" v-on="on">
                <v-list-item-title class="warning--text">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content v-else>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <span><v-icon dark>mdi-alert</v-icon> Beta Release</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>
<script>
  import { mapMutations } from "vuex";
  export default {
    data () {
      return {
        items: [
          { title: 'Confirmed Time Sheets', icon: 'mdi-table-check', page: 'default' },
          // { title: 'RHS Confirmed Time Sheets', icon: 'mdi-table-check', page: 'rhsPayroll', color: "warning", tooltip: true },
          { title: 'RHS workstream template', icon: 'mdi-table-check', page: 'rhsPayroll' },
          { title: 'Scheduled Hours', icon: 'mdi-table-clock', page: 'scheduled' },
          { title: 'Outstanding Hours', icon: 'mdi-table-check', page: 'outstanding' },
          { title: 'Payroll Settings', icon: 'mdi-table-cog', page: 'settings' },
        ],
        right: null,
        drawer: false,
        miniDefault: true,
        userCompanies: JSON.parse(localStorage.getItem("userCompanies")),
      }
    },

    computed: {
      mini:{
        get() {
          return this.miniDefault;
        },
        set(val) {
          this.miniDefault = val;
        },
      }
    },

    mounted() {
      this.hideRHSPayroll();
    },

    methods: {
      viewPage(item){
        this.setRhsPayrollPage(false);
        this.setDefaultPage(false);
        this.setScheduledPage(false);
        this.setOutstandingPage(false);
        this.setSettingsPage(false);

        switch(item.page) {
          case "default": {
            this.setDefaultPage (true);
            break;
          }
          case "outstanding": {
            this.setOutstandingPage(true);
            break;
          }
          case "scheduled": {
            this.setScheduledPage(true);
            break;
          }
          case "settings": {
            this.setSettingsPage(true);
            break;
          }
          case "rhsPayroll": {
            this.setRhsPayrollPage (true);
            break;
          }
          default: {
            this.setDefaultPage (true);

            this.setRhsPayrollPage (false);
            break;
          }
        }

        this.miniDefault = true;
      },

      hideRHSPayroll() {
        if (!this.userCompanies.includes("64a29e0cd378e000143694dd")) {
          this.items = this.items.filter(item => item.page != 'rhsPayroll')
        }
      },

      ...mapMutations("payroll", {
        setRhsPayrollPage: "SET_RHSPAYROLL_PAGE",
        setDefaultPage: "SET_DEFAULT_PAGE",
        setScheduledPage: "SET_SCHEDULED_PAGE",
        setOutstandingPage: "SET_OUTSTANDING_PAGE",
        setSettingsPage: "SET_SETTING_PAGE",
      }),
    },

  }
</script>
